<template>
  <div class="userLayout">
    <div class="navLeft">
      <el-row class="tac">
        <el-col >
          <el-menu default-active="/dataCenter" class="el-menu-vertical-demo" router unique-opened>
            <el-menu-item index="/dataCenter">
              <i class="el-icon-menu"></i>
              <span slot="title">数据中心</span>
            </el-menu-item>

            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-s-custom"></i>
                <span>我的</span>
              </template>
              <el-menu-item index="/myApi">我的API</el-menu-item>
              <el-menu-item index="/applyApi">申请API</el-menu-item>
              <el-menu-item index="/myOrder">我的订单</el-menu-item>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span>账号管理</span>
              </template>
              <el-menu-item index="/updatePwd">修改密码</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-row>
    </div>
    <div class="navRight">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  methods: {}
}
</script>

<style lang="less" scoped>
.userLayout {
  display: flex;
  justify-content: space-between;
  height: 100vh;
  .navLeft {
    width: 20%;
    height: 100%;
    border-right: solid 1px #e6e6e6;
    border-collapse: collapse;
    .el-menu {
    border-right: none;
}
  }
  .navRight {
    width: 80%;
  }
}
</style>
